import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';
import { useConfig } from '../contexts/ConfigContext.js';
import { useDraftData } from '../hooks/useDraftData.js';
import DraftBoard from './draft/DraftBoard.js';
import DraftablePlayersList from './draft/DraftablePlayersList.js';

const Draft = () => {
  const navigate = useNavigate();
  const { seasonID } = useParams();
  const config = useConfig();
  const SEASON = seasonID || config.currentSeason;

  const {
    draft, players, games, allGameStats, teams,
    computedDraftPicks, dataReady, draftExists,
  } = useDraftData(SEASON);

  const isPastDraft = parseInt(SEASON) < parseInt(config.currentSeason);

  const seasonNumbers = Array.from(
    { length: parseInt(config.currentSeason) },
    (_, i) => String(i + 1)
  );

  const scrollToCurrentPick = () => {
    const el = document.getElementById('current-pick');
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 250;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  if (!dataReady) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    );
  }

  return (
    <div className="Schedule">
      <div className="league-content">
        <div className="league-body">
          <div className="league-table-container schedule">
            <p className="league-title-standard-secondary text-align-center">
              Season {SEASON} Draft
            </p>

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 12 }}>
              {seasonNumbers.map(s => (
                <button
                  key={s}
                  className={`btn btn-sm ${s === SEASON ? 'btn-dark' : 'btn-outline-secondary'}`}
                  onClick={() =>
                    navigate(s === config.currentSeason ? '/draft' : `/draft/seasons/${s}`)
                  }
                >
                  Season {s}
                </button>
              ))}
            </div>

            {draftExists && (
              <a
                className="league-type"
                style={{ textTransform: 'math-auto' }}
                onClick={scrollToCurrentPick}
              >
                Jump to current pick
              </a>
            )}
          </div>
        </div>

        {!draftExists ? (
          <div className="league-body">
            <div className="league-table-container schedule">
              <p className="text-align-center" style={{ color: '#666' }}>
                {isPastDraft
                  ? `No draft data was collected for Season ${SEASON}.`
                  : `The Season ${SEASON} draft has not started yet.`}
              </p>
            </div>
          </div>
        ) : (
          <div className="league-body">
            <div className="league-table-container schedule">
              <DraftBoard
                computedDraftPicks={computedDraftPicks}
                onPickClick={teamID => navigate(isPastDraft ? `/teams/${teamID}/seasons/${SEASON}` : `/teams/${teamID}`)}
              />
            </div>
            <DraftablePlayersList
              draft={draft}
              allGameStats={allGameStats}
              games={games}
              season={parseInt(SEASON)}
              computedDraftPicks={computedDraftPicks}
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Draft;
